import { Tooltip as VisxTooltip } from '@visx/tooltip';

import useTooltipContext from './useTooltipContext';
import { getClampedLeftValue, getRelativeParentDomRect } from './utils';

const Tooltip = (): JSX.Element | null => {
  const { tooltipTop, tooltipLeft, tooltipOpen, tooltipData, boundsRef } =
    useTooltipContext();

  const domRect = getRelativeParentDomRect(boundsRef);

  if (!tooltipOpen) return null;

  const leftVal = getClampedLeftValue(
    tooltipLeft,
    domRect?.left,
    domRect?.right
  );

  const hideTooltip = !leftVal;

  return (
    <span
      data-testid="Tooltip"
      style={{
        pointerEvents: 'none',
        display: 'inlineBlock',
        opacity: hideTooltip ? 0 : 1, // it still needs to mount for measurement
      }}
    >
      <VisxTooltip
        top={tooltipTop}
        left={leftVal}
        offsetLeft={0}
        offsetTop={0}
        applyPositionStyle
        unstyled
      >
        {tooltipData}
      </VisxTooltip>
    </span>
  );
};

export default Tooltip;
